import {useEffect} from "react";

export default function PrivacyPolicy({className, ...props}) {


    // move to top

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="privacy-policy container mx-auto p-6 bg-gray-50 rounded-lg shadow-md">
            <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">Privacy Policy</h1>
            <p className="text-gray-700 mb-4">
                This Privacy Policy ("Policy") describes how Detstudy ("we," "us," or "our") collects, uses, and
                discloses personal information when you use Detstudy ("the Website").
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Information We Collect</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                    <strong>Information You Provide:</strong> When you register an account, complete forms, or
                    communicate with us, we may collect personal information such as your name, email address, and other
                    contact details.
                </li>
                <li>
                    <strong>Usage Information:</strong> We may automatically collect information about your use of the
                    Website, including IP address, browser type, device information, and pages visited.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Use of Information</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                    We use the information we collect to provide and improve the Website, respond to inquiries, and
                    personalize your experience.
                </li>
                <li>
                    We may also use your information to send promotional emails or updates about our services, but you
                    can opt out of these communications at any time.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Sharing of Information</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>We do not sell, trade, or rent your personal information to third parties.</li>
                <li>
                    We may share your information with service providers who assist us in operating the Website or
                    conducting our business, subject to confidentiality obligations.
                </li>
                <li>
                    We may disclose your information if required by law or to protect our rights or the rights of
                    others.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Cookies and Similar Technologies</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                    We use cookies and similar technologies to analyze trends, administer the Website, track users'
                    movements, and gather demographic information.
                </li>
                <li>
                    You can control cookies through your browser settings and opt out of certain tracking by adjusting
                    your preferences.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Data Security</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>
                    We implement security measures to protect your information from unauthorized access, alteration,
                    disclosure, or destruction.
                </li>
                <li>
                    However, no method of transmission over the internet or electronic storage is 100% secure, and we
                    cannot guarantee absolute security.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Children's Privacy</h2>
            <p className="text-gray-700 mb-4">
                The Website is not intended for children under 13 years of age, and we do not knowingly collect personal
                information from children under this age.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Your Choices</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>You can update or correct your account information by logging into your account settings.</li>
                <li>
                    You can opt out of receiving promotional emails by following the instructions in the email or
                    contacting us directly.
                </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Changes to this Policy</h2>
            <p className="text-gray-700 mb-4">
                We reserve the right to update or modify this Privacy Policy at any time. Any changes will be effective
                immediately upon posting the revised Policy on the Website.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">Contact Us</h2>
            <p className="text-gray-700">
                If you have any questions about this Privacy Policy or our practices regarding your personal
                information, please contact us at <a href="mailto:detstudynow@gmail.com"
                                                     className="text-blue-600 underline">detstudynow@gmail.com</a>.
            </p>
        </div>

    )
}